import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/__auth/admin/users")({
    component: UsersLayout,
});

function UsersLayout() {
    return <Outlet />;
}
